import {
  Box,
  Typography,
  Paper,
  IconButton,
  useTheme,
  useMediaQuery,
  Chip
} from '@mui/material';
import { ArrowBack, WifiOff } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

type Props = {
  jobNumber: string;
  onBack: () => void;
  isOffline?: boolean;
};

export const ReviewHeader = ({ jobNumber, onBack, isOffline }: Props) => {
  const { t } = useTranslation('customerReview');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Paper elevation={1} sx={{ p: { xs: 1.5, sm: 2 }, mb: 1.5 }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5
        }}
      >
        <IconButton
          onClick={onBack}
          size="small"
          sx={{
            color: theme.palette.text.secondary,
            '&:hover': {
              color: theme.palette.primary.main,
              backgroundColor: theme.palette.action.hover
            }
          }}
        >
          <ArrowBack />
        </IconButton>

        <Typography
          variant={isMobile ? 'h6' : 'h5'}
          sx={{ fontWeight: 'bold', color: 'primary.main', flex: 1 }}
        >
          {t('reviewWorkOrder', { jobNumber })}
        </Typography>

        {isOffline && (
          <Chip
            icon={<WifiOff />}
            label={t('offline')}
            color="warning"
            variant="outlined"
            size="small"
            sx={{
              height: 28,
              fontSize: '0.75rem',
              fontWeight: 500,
              borderRadius: 2,
              borderWidth: 1.5
            }}
          />
        )}
      </Box>
    </Paper>
  );
};
